<ng-container *ngIf="!!notifications && notifications.length > 0">
  <div class="notification-list__title">
    <span>{{ title | translate }}</span>
  </div>

  <div class="notification-list__list" data-qa="genesys-call-log_notification-list">
    <div
      *ngFor="let notification of notifications"
      class="notification-list__notification"
    >
      <horizon-icon
        [iconName]="'warning_w'"
        [iconGroup]="'tooltip'"
        [color]="globalSettings.colors.warningColor"
        [size]="'13'"
      ></horizon-icon>
      <span>
        {{
          "call_log.call_log_report_view.notifications.list.message"
            | translate : { field: notification.fields.fieldName }
        }}
      </span>
    </div>
  </div>
</ng-container>
